import React from "react";
import { useSpringCarousel } from "react-spring-carousel-js";
import { CarouselWrapper, NavButton } from "./carousel-styles";
import bxsSkipNextCircle from "@iconify/icons-bx/bxs-skip-next-circle";
import bxsSkipPreviousCircle from "@iconify/icons-bx/bxs-skip-previous-circle";
import { Icon } from "@iconify/react";

export const Carousel = ({ carouselItems, itemsPerSlide }) => {
  const { carouselFragment, slideToPrevItem, slideToNextItem } = useSpringCarousel({
    withLoop: true,
    itemsPerSlide: itemsPerSlide,
    items: carouselItems,
  });

  return (
    <CarouselWrapper>
      <NavButton $type="prev" onClick={slideToPrevItem}>
        <Icon icon={bxsSkipPreviousCircle} color="#fff" style={{ fontSize: 40 }} />
      </NavButton>
      {carouselFragment}
      <NavButton $type="next" onClick={slideToNextItem}>
        <Icon icon={bxsSkipNextCircle} color="#fff" style={{ fontSize: 40 }} />
      </NavButton>
    </CarouselWrapper>
  );
};
